import { useToast } from '@chakra-ui/react';
import { useGetInspectionExport } from '../../../services/api/generated/client';
import { localise } from '../../../services/lang/lang';
const useExportInspectionUseCase = (inspectionId) => {
    const toast = useToast();
    const { refetch, isFetching } = useGetInspectionExport(inspectionId, {
        query: { enabled: false },
    });
    const execute = async () => {
        const { data, isError } = await refetch();
        if (!data || isError) {
            toast({
                description: localise('UNABLE_TO_EXPORT_INSPECTION'),
                status: 'error',
            });
            return;
        }
        const url = window.URL.createObjectURL(data.data);
        window.open(url);
    };
    return { execute, isFetching };
};
export default useExportInspectionUseCase;
